<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <h5 class="text-center"><b>Welcome, {{ authUser.name }}</b></h5>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'HomeUser',
  computed: {
    ...mapState({
      authUser: state => state.users.authUser
    })
  }
}
</script>
